// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2ApZ8","empty":"ModalGraph_empty__gEwQj"};